

















































































































































































































































































import _ from 'lodash';
import hash from 'object-hash';
import { editFactory } from '@/main/pages';
import { Cell, getColumnsRowMapObject, Row } from '@/main/utils/table';
import { ERROR } from '@/main/store/actionTypes';
import { openEdit, openList } from '@/main/router/routerPath';
import { apiProvider as zakazkaProvider } from '@/modules/servis/zakazka/api';
import { PageMode } from '@/main/utils/pageMode';
import { ZAKAZKA_DRUH, ZAKAZKA_DRUH_LOCALIZED, ZAKAZKA_STAV, NAME as ZAKAZKA_NAME } from '@/modules/servis/zakazka/constants';
import { showNotification, showAlert } from '@/main/utils/notifications';
import { saveButton, deleteButton } from '@/main/utils/tableOperations';
import { forceFileDownload, validateFiletype } from '@/main/utils/fileHelper';

import { FILE_TYPE, MAXIMUM_FILE_SIZE, ScreenSize } from '@/main/components/constants';

import { objectToCamelCaseShallow } from '@/main/utils/stringHelper';

import { OrderSubType } from '@/modules/uctenky/fakturace/constants';

import { LAST_ODOMETER } from '@/main/store/constants';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';
import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import VozidloRidicSelect from './components/VozidloRidicSelect.vue';
import { types } from './store/types';
import { store } from './store/edit';
import { apiProvider } from './api';
import { NAME, POLOZKY, DEPENDENT_TABLES, RPZV_STATUS, POLOZKY_COLS, ZAKAZKA_LIST_FILES, PENDING_JOB_LIST, JOB_LIST_STATUS, SAVE_JOBLIST, LOAD_JOBLIST } from './constants';
import { ServisniPakety } from '../servisniPakety';
import DropButtons from '../components/DropButtons.vue';
import { DefaultCurrency } from '../components/AdvancePay/constants';
import { convertToObjects } from '@/main/utils/table';
type TextValue = { Text: string; Value: string };

export default editFactory(NAME, store).extend({
	components: {
		VozidloRidicSelect,
		DmsPdfDialog,
		DmsEditableTable,
		DropButtons,
	},
	props: {
		filter: { type: Object, default: (): { VozidloId: number | null } => ({ VozidloId: null }) },
	},
	data() {
		return {
			polozkyCols: POLOZKY_COLS,
			uploadFileDialog: {
				visible: false,
				title: 'Update',
				notificationDialogMsg: this.LocalizeChyboveHlasky('odiUpload'),
				handleClose: () => {},
			},
			saveButton,
			deleteButton,
			fileList: [] as any[],
			palivoStavMarks: {
				0: '0/R',
				1: '',
				2: '',
				3: '',
				4: '1/1',
			},
			showTiskDialog: false,
			dependencies: DEPENDENT_TABLES,
			ZAKAZKA_LIST_FILES,
			PENDING_JOB_LIST,
			dialog: {
				visible: false,
				rpzv: false,
				klonZakazky: false,
				title: '',
			},
			klonovanaZakazkaDruh: ZAKAZKA_DRUH.DILENSKA,
			cellIndex: 0,
			reportUrl: '/Reports/Reports/GetZakazkovyListReportPdf' as string,
			lstOrdersButtons: [
				{ labelKey: '' as string | null, click: '' as string | null, disable: '' as string | boolean | null, exist: true as boolean | null },
			],
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,			
		};
	},
	computed: {
		titleText(): string {
			return this.uploadFileDialog.title;
		},
		rpzvUploadFoto(): boolean {
			return (
				this.RpzvCommunicStatusPzn === RPZV_STATUS.ODESLANO_OK
				|| this.RpzvCommunicStatusPzn === RPZV_STATUS.ODESLANO_CHYBA
				|| this.RpzvCommunicStatusPzn === RPZV_STATUS.NEODESLANO_DMS
			);
		},
		rpzvUploadKm(): boolean {
			return this.RpzvCommunicStatusPzn === RPZV_STATUS.ODESLANO_CHYBA || this.RpzvCommunicStatusPzn === RPZV_STATUS.NEODESLANO_DMS;
		},
		disableRpzv(): boolean {
			return this.RpzvCommunicStatusPzn === RPZV_STATUS.ODESLANO_PHOTO || this.rpzvSent;
		},
		dependenciesById(): string[] {
			return [];
		},
		dependeciesByFilter(): string[] {
			return [POLOZKY, ZAKAZKA_LIST_FILES, PENDING_JOB_LIST];
		},
		isFormDataChanged(): boolean {
			return hash(this.edit) !== this.editHash || hash(this.dependentTables.Polozky.rows) !== this.dependentTables.Polozky.hash;
		},
		mutationsMapper(): Record<string, string> {
			return {
				vozidloRidic: `${this.storeUri}/${types.mutations.VOZIDLO_RIDIC_MAPPER}`,
			};
		},
		rozsireniDisabled(): boolean {
			return this.ZakazkaStav === ZAKAZKA_STAV.UZAVRENA || this.ZakazkaStav === ZAKAZKA_STAV.UVOLNENA || !this.TiskDat;
		},
		modelVozidla(): string {
			return this.Typkod !== null && this.TypkodText !== null ? `${this.Typkod}, ${this.TypkodText}` : '';
		},

		areAllDisabled(): boolean {
			return (
				this.ZakazkaStav === ZAKAZKA_STAV.UZAVRENA
				|| this.ZakazkaStav === ZAKAZKA_STAV.UVOLNENA
				|| this.ZakazkaStav === ZAKAZKA_STAV.VYRAZENA
				|| this.isViewMode
				|| !!this.TiskDat
			);
		},

		M2FixacePrp(this: Vue) {
			return this.$store.state.loggedUser.OrganizaceData.M2FixacePrp;
		},

		infSmsTelNrSelectList(): TextValue[] {
			return this.toSelectList([this.TelfmaNr, this.TelmobNr, this.TelprivNr, this.VrTelNr]);
		},

		infMailAdresaSelectList(): TextValue[] {
			return this.toSelectList([this.EMailAdresa, this.VrEMailAdresa]);
		},

		infSmsTelNrDisabled(): boolean {
			return this.areAllDisabled || !this.InfSmsPrp;
		},

		infMailAdresaDisabled(): boolean {
			return this.areAllDisabled || !this.InfMailPrp;
		},

		vybavaTexts(): any {
			const result = {} as any;
			this.dropdownList.VybavaVoz.forEach((o: any) => {
				result[o.Value] = o.Text;
			});
			return result;
		},

		zakazkovyListTiskFilter(): { Id: number | null; VyrobekvozOzn: string | null } {
			return {
				Id: this.ZakazkalistId,
				VyrobekvozOzn: this.VyrobekvozOzn,
			};
		},
		technicalWorkTimeSheetReportFilter(): { ZakazkaId: number | null } {
			return {
				ZakazkaId: this.ZakazkalistId,
			};
		},
		isZakazkovyListTiskDisabled(): boolean {
			return this.ZakazkalistId === null;
		},

		isDriverRequired(): boolean {
			return this.VrTelNr !== null || this.VrJmeno !== null || this.VrPrijmeni !== null;
		},

		vozidloRidicFilter(): { VozidloId: string | null; RidicPrijmeni: string | null } {
			return {
				VozidloId: this.VozidloId,
				RidicPrijmeni: this.VrPrijmeni,
			};
		},

		// TODO: shouldn't this (checking changes in dependent tables) be base functionality?
		// If so, compute hash from dependentTables too and delete rowsHash and the mutation that sets it.
		isModified(): boolean {
			return this.isEditForm && (hash(this.edit) !== this.editHash || hash(this.dependentTables.Polozky.rows) !== this.dependentTables.Polozky.hash);
		},
		isMontazDv(): boolean {
			return this.ZakazkaDruh === ZAKAZKA_DRUH.MONTAZ_DV;
		},
		druhyKlonovaneZakazkyLocalized(): Record<string, any> {
			const druhyTmp = [ZAKAZKA_DRUH.DILENSKA, ZAKAZKA_DRUH.GARANCE, ZAKAZKA_DRUH.INTERNI_DILENSKA, ZAKAZKA_DRUH.KULANCE];
			const druhy = this.ZakazkaDruh === ZAKAZKA_DRUH.MONTAZ_DV ? [...druhyTmp, ZAKAZKA_DRUH.MONTAZ_DV] : druhyTmp;
			return _.pick(ZAKAZKA_DRUH_LOCALIZED, druhy);
		},
		klonZakazkyModalLabel(): string {
			return this.LocalizeFormular('dlgZakazka');
		},
		RPZVModalLabel(): string {
			return this.LocalizePopisostatni('RPZV');
		},
		orderButtons(): object {
			this.lstOrdersButtons =			[
				{ labelKey: 'CompleteJobList', click: 'tiskZakazkaList', disable: this.isZakazkovyListTiskDisabled, exist: true },
				{ labelKey: 'ServisNabidky', click: 'onServisniNabidkyClick', disable: false, exist: true },
				{ labelKey: 'cmdKlonZakazky', click: 'showKlonZakazky', disable: false, exist: true },
				{ labelKey: 'cmdZLRozsireni', click: 'rozireni', disable: !this.areAllDisabled || this.isViewMode, exist: true },
				{ labelKey: 'PrintTimesheet', click: 'onPrintTimesheet', disable: false, exist: this.dmsSys.WarrantyPrp },
			];
			return this.lstOrdersButtons
				.filter((item) => item.labelKey !== undefined && item.labelKey != null && item.exist)
				.map((item) => ({
					labelKey: item.labelKey,
					click: () => { this.call(item.click); },
					exist: item.exist,
					disable: item.disable,
				}));
		},
		isTabletEnabled(): boolean {
			return this.windowWidth > this.screenSize;
		},
		getCurrency(): number | null {
			this.MenaId2 = (this.dropdownList.Mena as any).filter((x:any) => x.Text === DefaultCurrency.PrimaryText || x.Text === DefaultCurrency.SecondaryText)[0]?.Value;
			return this.MenaId2;
		},
	},
	watch: {
		async KurzM2(val) {
			if (val === 0) {
				const menaKurzTxt = await this.LocalizeChyboveHlasky('MenaKurzJe0');
				const mena1Text = this.dropdownList.Mena.find((item) => item.Value === this.MenaId1)?.Text;
				const mena2Text = this.dropdownList.Mena.find((item) => item.Value === this.MenaId2)?.Text;
				this.showErrorAlert({ message: `(${mena1Text}-${mena2Text}) ${menaKurzTxt} `, localizeMessage: false }); // tuna to nemoze byt
				this.MenaId2 = null;
				this.CenaOdhadM2 = null;
				this.KurzM2 = null;
			}
		},
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
	},
	methods: {
		call(method:any) {
			(this as { [key:string]:any })[method]();
		},
		getSourceTypeDetails(row: Row, columnId: number) {
			return this.dropdownList.SourceType.find((item) => item.Value === row.cells[columnId])?.Text;
		},

		getRemarkTypeDetails(row: Row, columnId: number) {
			return this.dropdownList.RemarkType.find((item) => item.Value === row.cells[columnId])?.Text;
		},
		cancelRowEditReject(rowSelect: Row) {
			this.showConfirm({
				message: `${this.LocalizeChyboveHlasky('IsJoblistReject')}`,
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					cancelButtonText: this.Localize('Ne'),
					confirmButtonText: this.Localize('Ano'),
					callback: async (action) => {
						if (action === 'confirm') {
							const isJoblistApprovedIndex = this.dependentTables.Polozky.cellNames!.EXECUTED;
							rowSelect.cells[isJoblistApprovedIndex] = JOB_LIST_STATUS.REJECTED;
							this.$emit('row-saved', { row: rowSelect });
						}
					},
				},
			});
		},
		rowApprove(rowSelect: Row) {
			this.showConfirm({
				title: this.LocalizeChyboveHlasky('questionTitle'),
				message: `${this.LocalizeChyboveHlasky('IsJoblistApprove')}`,
				options: {
					cancelButtonText: this.Localize('Ne'),
					confirmButtonText: this.Localize('Ano'),
					callback: async (action) => {
						if (action === 'confirm') {
							const iSJoblistApprovedIndex = this.dependentTables.Polozky.cellNames!.EXECUTED;
							rowSelect.cells[iSJoblistApprovedIndex] = JOB_LIST_STATUS.APPROVED;
							this.$emit('row-saved', { row: rowSelect });
						}
					},
				},
			});
		},
		async jobCardFilesDownload(e: Event, cells: Cell[]) {
			this.startLoading();
			const MappedRow = getColumnsRowMapObject(this.dependentTables.ZakazkaListFiles.columns, cells) as any;
			const file = await apiProvider.getDocuments(MappedRow.ID);
			const url = `data:application/octet-stream;base64,${file.data}`;
			forceFileDownload(url, MappedRow.FILE_NAME);
			this.endLoading();
		},
		async jobCardFilesDelete(e: Event, cells: Cell[]) {
			await apiProvider.deleteDocuments(cells[0]);
			await this.refreshTable(ZAKAZKA_LIST_FILES);
		},
		async submitUpload() {
			const validateFile = validateFiletype(this.fileList[0], MAXIMUM_FILE_SIZE, FILE_TYPE);
			if (!validateFile.result) {
				showAlert({
					message: this.LocalizeChyboveHlasky(validateFile.message),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			this.startLoading();
			await apiProvider.saveDocument(this.fileList[0], this.ZakazkaId);
			this.fileList = [];
			await this.refreshTable(ZAKAZKA_LIST_FILES);
			this.endLoading();
		},
		handleChange(file: Record<string, any>) {
			this.fileList = [file];
		},
		handleRemove(file: File, fileList: []) {
			this.fileList = fileList;
		},
		async saveClick() {
			const startTime = performance.now();
			this.startLoading();

			if(!await this.isOdometerValid()){
				return;
			}
			
			const isValidSource = this.checkSourceTypeForItems();
			if(!isValidSource){
				return;
			}
			const isEstimation = this.isEstimationRequired();
			if (isEstimation) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_ESTIMATION') });
				return;
			}
			if (this.dependentTables.ZakazkaListFiles.rows.length === 0 && this.OrderSubtypeId === 4) {
				this.uploadFileDialog.visible = true;
				return;
			}
			if (this.KmStavOut !== null && this.KmStav! > this.KmStavOut!) {
				this.onBlurKmOutHandler();
				return;
			}

			await this.save(!this.RpzvPrp);
			if (this.RpzvPrp) {
				await this.entity();
			}
			if (this.loggedUser.DmsSys.CustomerFirstPrp) {
				await zakazkaProvider.sendNotificationForSafetyRemark(this.ZakazkaId!);
			}
			let totalTimeTaken = performance.now() - startTime;
			let seconds = parseFloat((totalTimeTaken / 1000).toFixed(2));
			await apiProvider.logPerformance('OrderPrp', 'Job List', SAVE_JOBLIST, seconds);
		},
		async loadData() {
			const startTime = performance.now();
			this.getKurzy();
			this.fetchTableSchemaData(this.dependenciesById);
			this.fetchTableSchemas(this.dependeciesByFilter);
			if (this.isCreateMode) {
				await this.default();
			} else {
				await this.entity();
				this.fetchTableData(this.dependeciesByFilter);
			}
			this.showDialogPendingJoblist = true;
			this.loadedData();
			let totalTimeTaken = performance.now() - startTime;
			let seconds = parseFloat((totalTimeTaken / 1000).toFixed(2));
			await apiProvider.logPerformance('OrderPrp', 'Job List', LOAD_JOBLIST, seconds);
		},
		async onBlurHandler() {
			let isValid = false;
			if (this.dmsSys.CustomerRevisitPrp && this.OrderSubtypeId !== OrderSubType.BODY_SHOP) {
				if (!_.isNull(this.filter.VozidloId) && !_.isNull(this.KmStav)) {
					this.startLoading();
					const { data: revisitData } = await apiProvider.getRepeatRepairRevisit(this.filter.VozidloId!, this.KmStav!);
					this.endLoading();
					const { lastOdomerReading, revisitDate, isRevisit } = objectToCamelCaseShallow(revisitData);
					if (isRevisit) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky('CarDetailInformation').replace(LAST_ODOMETER, `${lastOdomerReading}`).replace('<LAST_SERVICE>', `${revisitDate}`),
							localizeMessage: false,
							title: this.LocalizeChyboveHlasky('infoTitle'),
						});
						localStorage.Revisit = this.KmStav;
						isValid = false;
					}
				}
			}
			this.onBlurKmOutHandler();
			return isValid;
		},
		async onBlurKmOutHandler() {
			if (this.KmStavOut !== null && this.KmStav! > this.KmStavOut!) {
				this.showErrorAlert({
					message: `${this.LocalizeChyboveHlasky('OdometerOutError')}`,
					localizeMessage: false,
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: { type: 'error' },
				});
			}
		},
		async loadedData() {
			this.dependentTables.Polozky.columns.forEach((column) => {
				column.isEditable = true;
			});
			this.startLoading();
			this.checkVozidloId();
			const { data } = await apiProvider.getLatestOrderKms(this.KaroserieNr!);
			this.lastStavKm = data?.LastMileage;
			this.endLoading();
			this.recomputeHash();
		},
		rozireni() {
			this.rozsireniZakList(this.M2FixacePrp);
		},
		async sendRpzvKm() {
			if (this.ZakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_ZBOZI && !this.KmStav) {
				showNotification({ title: this.Localize('Chyba'), message: this.LocalizeChyboveHlasky('MissKm') });
			} else {
				this.startLoading();
				if (this.fileList.length === 0) {
					await apiProvider.sendRpzvKm(this.ZakazkalistId);
				} else {
					this.submitPhotoUpload();
				}
				await this.entity();
				this.endLoading();
			}
		},
		async submitPhotoUpload() {
			const file = this.fileList[0];
			if (file) {
				this.startLoading();
				await apiProvider.sendRpzvKmPhoto(file, this.ZakazkalistId);
				await this.entity();
				this.rpzvSent = true;
				this.endLoading();
			}
		},
		async openRPZVList() {
			await this.getRpzvLog();
			this.dialog.visible = true;
			this.dialog.rpzv = true;
			this.dialog.title = this.RPZVModalLabel;
		},
		showKlonZakazky() {
			this.dialog.visible = true;
			this.dialog.klonZakazky = true;
			this.dialog.title = this.klonZakazkyModalLabel;
		},
		closeDialog() {
			this.dialog.visible = false;
			this.dialog.klonZakazky = false;
			this.dialog.rpzv = false;
		},

		 checkSourceTypeForItems():boolean
		{
			var isValidSourceType = true;
			const partsData = convertToObjects(this.dependentTables.Polozky).map((part, idx) => {
				if (part.SourceType === null) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_SOURCE_TYPE') });
				  isValidSourceType = false;
				}
			});
			return isValidSourceType;
		},
		async tiskZakazkaList() {
            const startTime = performance.now();
			if(!await this.isOdometerValid()){
				return;
			}
			const isValidSource = this.checkSourceTypeForItems();
			if(!isValidSource){
				return;
			}
			else{
			const result = await this.save(false);
			if (result && !(result instanceof Error)) {
				const resp = await this.tiskZakList(result);
				if (!(resp instanceof Error)) {
					this.showTiskDialog = false;
					await apiProvider.uzavreni(this.ZakazkalistId);
					let totalTimeTaken = performance.now() - startTime;
					let seconds = parseFloat((totalTimeTaken / 1000).toFixed(2));
					await apiProvider.logPerformance('OrderPrp', 'Job List', SAVE_JOBLIST, seconds);
					this.isEditMode && (await this.refreshPage());
				}
			}
			}
		},

		onSectiOdhadyClick() {
			this.CenaOdhad = _.reduce(this.dependentTables.Polozky.rows, (sum, row) => sum + row.cells[4], 0);
		},

		toSelectList(array: (string | null)[]): TextValue[] {
			_.remove(array, (o) => o === null);

			return _.map(array as string[], (o) => ({ Text: o, Value: o }));
		},

		onZasilatSmsClick() {
			if (this.InfSmsPrp && this.infSmsTelNrSelectList.length === 1 && (!this.InfSmsTelNr || _.trim(this.InfSmsTelNr) === '')) {
				this.InfSmsTelNr = this.infSmsTelNrSelectList[0].Value;
			}
			if (!this.InfSmsPrp) {
				this.InfSmsTelNr = null;
			}
		},

		onZasilatEmailClick() {
			if (this.InfMailPrp && this.infMailAdresaSelectList.length === 1 && (!this.InfMailAdresa || _.trim(this.InfMailAdresa) === '')) {
				this.InfMailAdresa = this.infMailAdresaSelectList[0].Value;
			}
			if (!this.InfMailPrp) {
				this.InfMailAdresa = null;
			}
		},

		onVybavaClick(value: any) {
			const item = this.vybavaTexts[value];
			this.Vybava = _.trim(this.Vybava!);
			if (this.isBlank(this.Vybava)) {
				this.Vybava += `${item}`;
			} else if (_.endsWith(this.Vybava!, ',')) {
				this.Vybava += ` ${item}`;
			} else {
				this.Vybava += `, ${item}`;
			}
		},

		isBlank(value: string | null | undefined) {
			return value === null || value === undefined || _.trim(value) === '';
		},

		async getMeny() {
			if (this.meny) return;

			const result = await apiProvider.getMena();
			const tmp = {} as any;

			result.data.forEach((dataRow: any) => {
				tmp[dataRow.Cells['2']] = dataRow.Cells['0'];
			});
			this.meny = tmp;
		},

		async getKurzy() {
			if (this.kurzy) return;
			try {
				await this.getMeny();

				const tmp = {};
				const result = await apiProvider.getMenaKurz();

				result.data.forEach((dataRow: any) => {
					const mena1 = this.meny![dataRow.Cells['2']];
					const mena2 = this.meny![dataRow.Cells['3']];
					const k = {
						jednotkyZdr: dataRow.Cells['4'],
						jednotkyCil: dataRow.Cells['5'],
					};
					_.set(tmp, [mena1, mena2], k);
				});
				this.kurzy = tmp;
			} catch (err) {
				await this.$store.dispatch(ERROR, { err });
			}
		},

		async recomputeExchangeRate() {
			// @ts-ignore: 'This condition will always return false' this.MenaId2 gets assigned a string on it's el-select clear
			if (this.MenaId2 === null || this.MenaId2 === undefined) {
				this.CenaOdhadM2 = null;
				this.KurzM2 = null;
				this.MenaId2 = null; // in case it got assigned a string
			} else {
				const jednotky = this.kurzy[this.MenaId1 as any][this.MenaId2];
				this.KurzM2 = jednotky.jednotkyZdr;

				if (this.KurzM2 === 0) return;

				this.KurzM2 = jednotky.jednotkyCil / jednotky.jednotkyZdr;
				this.CenaOdhadM2 = this.CenaOdhad! * this.KurzM2;
			}
		},

		checkVozidloId() {
			if (this.filter.VozidloId !== null) {
				this.VozidloId = this.filter.VozidloId;
			}
			if (!this.VozidloId && !this.isMontazDv) {
				const message = this.LocalizeChyboveHlasky('VozidloMissing');
				this.showErrorNotification(message);
				this.$router.back();
			}
		},
		polozkySummaryMethod({ data }: { data: any }) {
			let soucetCJ = 0;
			let celkem = 0;
			data.forEach((row: any) => {
				soucetCJ += row.cells[3] ? row.cells[3] : 0;
				celkem += row.cells[4] ? row.cells[4] : 0;
			});
			return [this.Localize('X_CELKEM'), null, soucetCJ, celkem.toFixed(2)];
		},
		onServisniNabidkyClick() {
			openList(ServisniPakety.name, { filter: { ZakazkaId: this.ZakazkaId } });
		},
		async isOdometerValid(): Promise<boolean> {
			try {
					const response = await apiProvider.getLatestOrderKms(this.KaroserieNr!);
					const data = response.data;
					if (this.KmStav != null && this.KmStav < data.LastMileage) {
						// Show warning if last mileage is greater than current mileage
								const lastServiceDate = data.LastServiceDate;
								const formattedDate = lastServiceDate
									? (lastServiceDate.includes('T') ? lastServiceDate.split('T')[0] : lastServiceDate)
									: this.LocalizeChyboveHlasky('UnknownDate');
								const message = this.LocalizeChyboveHlasky('OdometerInfo')
									.replace('<LAST_ODOMETER>', `${data.LastMileage}`)
									.replace('<LAST_SERVICE>', `${formattedDate}`);
						this.showErrorAlert({
							message,
							localizeMessage: false,
							title: this.LocalizeChyboveHlasky('infoTitle'),
						});
						return false;
					}
				} catch (error) {
					console.error('Error fetching latest km:', error);
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('FetchError'),
						localizeMessage: false,
						title: this.LocalizeChyboveHlasky('errorTitle'),
					});
				} finally {
					this.endLoading();
			}
			return true;
		},
		async customValidation() {
			let isValid = true;
			if (this.KmStav! < this.lastStavKm!) {
				isValid = await this.showConfirmMsg(`${this.LocalizeChyboveHlasky('LastKmLarger')}`, true, false, this.lastStavKm);
			} else if (this.KmStav! - 100000 > this.lastStavKm!) {
				isValid = await this.showConfirmPokracovat('LastKmRozdil100K');
			}
			const hotovoDat = new Date(this.HotovoDat!);
			if (hotovoDat!.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('NeplatneDatum') });
				isValid = false;
			}
			return isValid;
		},
		async onKlonZakazkyOkClicked() {
			this.closeDialog();
			this.startLoading();
			const { data: orderId } = await zakazkaProvider.klonZakazky({
				zakazkaId: this.ZakazkaId,
				filterZakazkaDruh: this.klonovanaZakazkaDruh,
			});
			const id = orderId ?? null;
			if (id === null || id < 0) {
				await openEdit(ZAKAZKA_NAME, PageMode.CREATE, {
					filter: {
						VozidloId: this.VozidloId,
						ZakaznikId: this.ZakaznikId,
						ZakazkaDruh: this.klonovanaZakazkaDruh,
					},
				});
			} else {
				await openEdit(ZAKAZKA_NAME, PageMode.EDIT, { id });
			}
			this.endLoading();
		},
		createRow() {
			(this.$refs.editableTable as any).createRow();
		},
		async onPrintDialogClosed() {
			this.refreshPreviousPage = true;
		},
		async onPrintTimesheet() {
			this.reportUrl = '/Uctenky/Reports/GetTechnicalWorkTimeSheetReport';
			this.showTiskDialog = true;
		},
		isEstimationRequired():boolean {
			let isRemarkExist = false;
			if (this.dependentTables.Polozky.rows.length > 0 && this.CenaOdhad == null) {
				isRemarkExist = true;
			}
			return isRemarkExist;
		},
},
});
